var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPlusRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.823,
    height: 13.823,
    viewBox: "0 0 13.823 13.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{stroke:props.stroke;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus-circle",
    "data-name": "Icon feather-plus-circle",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Path_66",
    "data-name": "Path 66",
    d: "M18,12V23.823",
    transform: "translate(-12.088 -12)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Path_67",
    "data-name": "Path 67",
    d: "M12,18H23.823",
    transform: "translate(-12 -12.088)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPlusRed);
export default __webpack_public_path__ + "static/media/icn_plus_red.f7a039f4.svg";
export { ForwardRef as ReactComponent };